export default __webpack_public_path__ + "assets/images/features_business_and_tourism-a7ec4efff98de2cd627ca6f63e4cc216.png";